import TomSelect from 'tom-select';

export default function tomSelectInput(targetElement, initialValue, onChange = null) {
  if (
    typeof targetElement === 'string' &&
    document.querySelectorAll(targetElement).length === 0
  ) {
    return;
  }

  const select = new TomSelect(targetElement, {
    plugins: ['remove_button'],
    maxOptions: 500,
    onChange: () => {
      if (onChange) {
        onChange();
      }
    }
  });

  if (initialValue) {
    select.setValue(initialValue, true); // true = silent (no change event - to play nice with dirty form)
  }

  return select;
}
